import { atom } from 'recoil';

export const showSideMenuAtom = atom<boolean>({
  key: 'showSideMenuAtom',
  default: true,
});
